/**
 * Utility functions for generating and formatting hash values
 */

/**
 * Generate SHA-256 hash from input text using Web Crypto API
 * @param text - Input text to hash
 * @returns Promise resolving to hex string representation of the hash
 */
export async function generateSHA256(text: string): Promise<string> {
  // Encode the text as UTF-8
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  
  // Generate the hash
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  
  // Convert buffer to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  
  return hashHex;
}

/**
 * Format hash string into chunks for grid display
 * @param hash - Hash string to format
 * @param charsPerRow - Number of characters per row
 * @returns Array of string chunks
 */
export function formatHashForGrid(hash: string, charsPerRow: number = 8): string[] {
  const chunks: string[] = [];
  for (let i = 0; i < hash.length; i += charsPerRow) {
    chunks.push(hash.slice(i, i + charsPerRow));
  }
  return chunks;
}
